import React from "react";
import { Box, Typography, Grid, Divider, Tooltip } from "@mui/material";
import theme from "../../../theme/Theme";

type Props = {
  productivityNumbers: any;
};

const trackerTooltips = Object.freeze({
  offholdFromManagerOrProviderReviewToday:
    "These are the cases that were on hold for a manager review and have been sent back to you, or were on hold for a document request and have received an update and need to be reviewed.",
  agedCasesNumber:
    "These are cases that have been eligible for coding for more than a 30 day threshold.",
  casesAssignedOvernight:
    "These are the cases that have arrived in your queue today. These cases could be newly assigned from the nightly distribution, or cases reassigned to you from other members of your team.",
  holdByCoder:
    "These are case you have put on hold for your own followup or research.",
  holdForDocumentationReview:
    "These are cases you have put on hold for a document request.",
  holdForManagerReview:
    "These are cases you have put on hold for manager review.",
  casesSubmittedToday:
    "These are cases you have finished today by submitting them for billing.",
  casesExcludedToday:
      "These are cases you have finished today by excluding them."
});

const trackerLabels = Object.freeze({
  offholdFromManagerOrProviderReviewToday: "Off Hold Today",
  agedCasesNumber: "Over 30 Days",
  casesAssignedOvernight: "New Cases Today",
  holdByCoder: "My Holds Today",
  holdForDocumentationReview: "Provider Holds Today",
  holdForManagerReview: "Manager Holds Today",
  casesSubmittedToday: "Submitted",
  casesExcludedToday: "Excluded",
});

export const ProductivityTracker = ({
  productivityNumbers,
  ...props
}: Props) => {
  return (
    <Grid
      item
      container
      spacing={2}
      xs={12}
      wrap="nowrap"
      direction={"row"}
      marginBottom={"20px"}
    >
      {Object.keys(productivityNumbers)?.length > 0 &&
        Object.keys(trackerLabels!).map((key, index) => (
          <React.Fragment key={`${key}-${index}`}>
            {index !== 2 && (
              <Tooltip title={trackerTooltips[key] ?? ""}>
                <Grid item key={index} xs={2}>
                  <Box
                    sx={{
                      minHeight: "40px",
                      maxHeight: "40px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      bgcolor: "white",
                      boxShadow: "3",
                      border: "1",
                      borderRadius: "4px"
                    }}
                  >
                    <Typography
                      variant="h2"
                      sx={{ marginLeft: "5px", color: "artisticTextHigh.main" }}
                    >
                      {productivityNumbers[key]?.toString()}
                    </Typography>
                    <Typography
                      variant="caption1"
                      sx={{
                        marginLeft: "5px",
                        color: "artisticTextMedium.main"
                      }}
                    >
                      {trackerLabels[key]}
                    </Typography>
                  </Box>
                </Grid>
              </Tooltip>
            )}

            {index === 3 && ( // Add a vertical divider after the fourth item
              <Grid item sx={{ width: "20px" }}>
                <Divider
                  orientation="vertical"
                  style={{
                    width: "2px",
                    backgroundColor: theme.palette.artisticStroke200.main
                  }}
                />
              </Grid>
            )}
          </React.Fragment>
        ))}
    </Grid>
  );
};
